


























































































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import {
  minLenght,
  hasAtLeastNumber,
  hasAtLeastLetter
} from '@/utils/validationPassword';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import RulePassword from '@/componentsV2/molecules/RulePassword/RulePassword.vue';
import Service from '@/api/ForgotService';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    FilledButton,
    Typography,
    ValidationProvider,
    ValidationObserver,
    Input,
    RulePassword
  }
})
export default class RecoveryPassword extends Vue {
  name = '';
  lastname = '';
  password = '';

  success = false;
  loading = false;

  enableFirstNameInput = false;
  enableLastNameInput = false;

  service = new Service();

  failedRulesPassword: string[] = [];

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  mounted() {
    if (!this.verifyType()) this.$router.push('/');

    if (this.$route.query.isSoftUser) this.verifySoftLogin();
  }

  verifySoftLogin() {
    const { name, lastname, hasFirstName, hasLastname } = this.$route
      .query as any;

    this.enableFirstNameInput = hasFirstName === 'false';
    this.enableLastNameInput = hasLastname === 'false';

    this.name = decodeURIComponent(name);
    this.lastname = decodeURIComponent(lastname);
  }

  async submit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (this.flagRulesPassword) {
      if (
        !this.isPasswordLengthValid ||
        !this.isPasswordNumberValid ||
        !this.isPasswordLetterValid
      ) {
        const failedRules = formRef.fields.password.failedRules;
        this.failedRulesPassword = Object.keys(failedRules);
        return null;
      }
    }

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    this.loading = true;

    const token = this.$route.params.token;
    const typeUser = this.$route.params.typeUser;

    const data = {
      resetToken: token,
      newPassword: this.password,
      firstName: this.enableFirstNameInput ? this.name : undefined,
      lastName: this.enableLastNameInput ? this.lastname : undefined
    };

    let response;

    if (typeUser === 'customer') {
      response = await this.service.newCustomerPassword(data);
    } else {
      response = await this.service.newBusinessPassword(data);
    }

    this.success = response.status < 400;

    this.loading = false;
  }

  clearFailedRulesPassword() {
    if (this.flagRulesPassword && this.$refs.observer) {
      this.failedRulesPassword = [];
    }
    return;
  }

  verifyType() {
    const typeUser = this.$route.params.typeUser;
    return typeUser === 'manager' || typeUser === 'customer';
  }

  handleGoToLogin() {
    const redirectLogin = this.$route.query.redirectLogin as string;

    if (redirectLogin) {
      return window.location.assign(redirectLogin);
    }

    this.$router.push({
      name: 'login',
      ...(this.isAxxessFlow && {
        query: this.$route.query
      })
    });
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get flagRulesPassword() {
    return this.flags.includes(flagKeys.enableRulesPassword);
  }

  get isPasswordLengthValid() {
    return minLenght(this.password);
  }

  get isPasswordNumberValid() {
    return hasAtLeastNumber(this.password);
  }

  get isPasswordLetterValid() {
    return hasAtLeastLetter(this.password);
  }

  get createNewPassFormCopies() {
    if (this.isAxxessFlow) {
      return {
        title: 'Create a new password',
        description:
          'By creating a new password, you will be able to access your Axxess offers.'
      };
    }

    return {
      title: 'Create a new password',
      description:
        'By creating a new password, you will be logged out from all devices that are associated with this account.'
    };
  }

  get successCopies() {
    if (this.isAxxessFlow) {
      return {
        title: 'Your password has been created',
        description: 'Now, please use your password to log in to your account.',
        actionLabel: 'Log In'
      };
    }

    return {
      title: 'Your password has been changed',
      description:
        'Now, please user your new password to log in to your account.',
      actionLabel: 'Back to log in'
    };
  }

  get rulesPassword() {
    if (this.isAxxessFlow) return 'required|axxess_password';
    if (this.flagRulesPassword) return 'required|min:8|has_letter|has_number';
    return 'required|min:5';
  }

  get passwordHelpText() {
    if (this.isAxxessFlow)
      return 'At least 8 characters, one letter and one number.';
    return 'At least 5 characters.';
  }

  get isAxxessFlow() {
    return (
      this.$route.query.utm_source && this.$route.query.utm_source === 'axxess'
    );
  }

  get isCustomer() {
    return this.$route.params.typeUser === 'customer';
  }
}
